// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var LongClickSpan = require("../ui-utils/LongClickSpan.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var LongClickPaper = require("../ui-utils/LongClickPaper.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var Expln_utils_data = require("../../rescript-utils/main/Expln_utils_data.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_cmp_jstf_to_svg = require("../explorer/MM_cmp_jstf_to_svg.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MM_cmp_frag_transform = require("./MM_cmp_frag_transform.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Code = require("@mui/icons-material/Code").default;
var Edit = require("@mui/icons-material/Edit").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var ButtonGroup = require("@mui/material/ButtonGroup").default;
var FormControl = require("@mui/material/FormControl").default;
var Logout = require("@mui/icons-material/Logout").default;
var CodeOff = require("@mui/icons-material/CodeOff").default;
var ZoomInMap = require("@mui/icons-material/ZoomInMap").default;
var ZoomOutMap = require("@mui/icons-material/ZoomOutMap").default;
var AccountTree = require("@mui/icons-material/AccountTree").default;
var ContentCopy = require("@mui/icons-material/ContentCopy").default;
var ContentPaste = require("@mui/icons-material/ContentPaste").default;
var MM_frag_transform_default_script = require("./MM_frag_transform_default_script.bs.js");
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var VisibilityOff = require("@mui/icons-material/VisibilityOff").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;
var ShapeLineSharp = require("@mui/icons-material/ShapeLineSharp").default;

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, key, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  return React.createElement("span", {
              title: title
            }, JsxPPXReactSupport.createElementWithKey(key, IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: color,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function setNewText(st, text) {
  return {
          newText: text,
          infoExpanded: st.infoExpanded,
          visExpanded: st.visExpanded
        };
}

function setInfoExpanded(st, infoExpanded) {
  return {
          newText: st.newText,
          infoExpanded: infoExpanded,
          visExpanded: st.visExpanded
        };
}

function setVisExpanded(st, visExpanded) {
  return {
          newText: st.newText,
          infoExpanded: st.infoExpanded,
          visExpanded: visExpanded
        };
}

var lastSyntaxTypeLocStorKey = "editor-last-syntax-type";

function getLastSyntaxType(param) {
  return Local_storage_utils.locStorReadString(lastSyntaxTypeLocStorKey);
}

function setLastSyntaxType(lastSyntaxType) {
  Local_storage_utils.locStorWriteString(lastSyntaxTypeLocStorKey, lastSyntaxType);
}

function rndSymbol(isFirst, key, sym, color, longClickEnabled, longClickDelayMs, symRename, onLeftClick, onAltLeftClick, spaceBackgroundColor, symbolBackgroundColor, cursorOpt, title, param) {
  var cursor = cursorOpt !== undefined ? cursorOpt : "auto";
  var tmp;
  if (isFirst) {
    tmp = React.createElement(React.Fragment, undefined);
  } else {
    var tmp$1 = {
      cursor: cursor
    };
    if (spaceBackgroundColor !== undefined) {
      tmp$1.backgroundColor = spaceBackgroundColor;
    }
    var style = tmp$1;
    if (longClickEnabled) {
      tmp = React.createElement(LongClickSpan.make, {
            longClickEnabled: longClickEnabled,
            longClickDelayMs: longClickDelayMs,
            onShortClick: Belt_Option.map(onLeftClick, (function (onLeftClick, clickAttrs) {
                    if (clickAttrs !== undefined && clickAttrs.alt) {
                      return Belt_Option.forEach(onAltLeftClick, (function (clbk) {
                                    Curry._1(clbk, undefined);
                                  }));
                    } else {
                      return Curry._1(onLeftClick, undefined);
                    }
                  })),
            onLongClick: onAltLeftClick,
            children: " ",
            style: style,
            title: title
          });
    } else {
      var partial_arg = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, (function (param) {
              return Belt_Option.forEach(onAltLeftClick, (function (clbk) {
                            Curry._1(clbk, param);
                          }));
            }), undefined);
      var partial_arg$1 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, (function (param) {
              return Belt_Option.forEach(onLeftClick, (function (clbk) {
                            Curry._1(clbk, param);
                          }));
            }), undefined);
      tmp = React.createElement("span", {
            style: style,
            title: title,
            onClick: (function (param) {
                return MM_react_common.clickHnd2(partial_arg$1, partial_arg, param);
              })
          }, " ");
    }
  }
  var match = color !== undefined ? [
      color,
      "bold"
    ] : [
      "black",
      "normal"
    ];
  var tmp$2 = {
    color: match[0],
    cursor: cursor,
    fontWeight: match[1]
  };
  if (symbolBackgroundColor !== undefined) {
    tmp$2.backgroundColor = symbolBackgroundColor;
  }
  var style$1 = tmp$2;
  var tmp$3;
  if (longClickEnabled) {
    tmp$3 = React.createElement(LongClickSpan.make, {
          longClickEnabled: longClickEnabled,
          longClickDelayMs: longClickDelayMs,
          onShortClick: Belt_Option.map(onLeftClick, (function (onLeftClick, clickAttrs) {
                  if (clickAttrs !== undefined && clickAttrs.alt) {
                    return Belt_Option.forEach(onAltLeftClick, (function (clbk) {
                                  Curry._1(clbk, undefined);
                                }));
                  } else {
                    return Curry._1(onLeftClick, undefined);
                  }
                })),
          onLongClick: onAltLeftClick,
          children: Belt_Option.getWithDefault(Belt_Option.flatMap(symRename, (function (__x) {
                      return Belt_HashMapString.get(__x, sym);
                    })), sym),
          style: style$1,
          title: title
        });
  } else {
    var partial_arg$2 = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, (function (param) {
            return Belt_Option.forEach(onAltLeftClick, (function (clbk) {
                          Curry._1(clbk, param);
                        }));
          }), undefined);
    var partial_arg$3 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, (function (param) {
            return Belt_Option.forEach(onLeftClick, (function (clbk) {
                          Curry._1(clbk, param);
                        }));
          }), undefined);
    tmp$3 = React.createElement("span", {
          style: style$1,
          title: title,
          onClick: (function (param) {
              return MM_react_common.clickHnd2(partial_arg$3, partial_arg$2, param);
            })
        }, Belt_Option.getWithDefault(Belt_Option.flatMap(symRename, (function (__x) {
                    return Belt_HashMapString.get(__x, sym);
                  })), sym));
  }
  return JsxPPXReactSupport.createElementVariadicWithKey(key, React.Fragment, {
              children: null
            }, [
              tmp,
              tmp$3
            ]);
}

function rndContText(stmtCont, symRename, onTextLeftClick, onTextAltLeftClick, onTreeLeftClick, onTreeAltLeftClick, longClickEnabledOpt, longClickDelayMsOpt, cursorOpt, renderSelectionOpt, title, param) {
  var longClickEnabled = longClickEnabledOpt !== undefined ? longClickEnabledOpt : false;
  var longClickDelayMs = longClickDelayMsOpt !== undefined ? longClickDelayMsOpt : 0;
  var cursor = cursorOpt !== undefined ? cursorOpt : "auto";
  var renderSelection = renderSelectionOpt !== undefined ? renderSelectionOpt : false;
  if (stmtCont.TAG === /* Text */0) {
    var syms = stmtCont.syms;
    var syms$1 = syms.length === 0 ? [
        {
          sym: Common.nbsp,
          color: undefined
        },
        {
          sym: Common.nbsp,
          color: undefined
        },
        {
          sym: Common.nbsp,
          color: undefined
        }
      ] : syms;
    return syms$1.map(function (stmtSym, i) {
                return rndSymbol(i === 0, String(i), stmtSym.sym, stmtSym.color, longClickEnabled, longClickDelayMs, symRename, Belt_Option.map(onTextLeftClick, (function (onTextLeftClick, param) {
                                  Curry._1(onTextLeftClick, i);
                                })), Belt_Option.map(onTextAltLeftClick, (function (onTextAltLeftClick, param) {
                                  Curry._1(onTextAltLeftClick, i);
                                })), undefined, undefined, cursor, title, undefined);
              });
  }
  var match = stmtCont._0;
  var match$1 = MM_wrk_editor.getIdsOfSelectedNodes(stmtCont);
  var selectedIds = match$1[1];
  var clickedId = match$1[0];
  var elems = [];
  elems.push(rndSymbol(true, "expr-type", match.exprTyp, undefined, false, 0, symRename, undefined, undefined, undefined, undefined, cursor, title, undefined));
  Expln_utils_data.traverseTree({
        contents: false
      }, {
        TAG: /* Subtree */0,
        _0: match.root
      }, (function (param, node) {
          if (node.TAG === /* Subtree */0) {
            return node._0.children;
          }
          
        }), undefined, (function (selectionIsOn, node) {
          if (node.TAG !== /* Subtree */0) {
            var id = node.id;
            var symbolIsHighlighted = Belt_SetInt.has(selectedIds, id);
            elems.push(rndSymbol(false, String(id), node.sym, node.color, longClickEnabled, longClickDelayMs, symRename, Belt_Option.map(onTreeLeftClick, (function (onTreeLeftClick, param) {
                            Curry._1(onTreeLeftClick, id);
                          })), Belt_Option.map(onTreeAltLeftClick, (function (onTreeAltLeftClick, param) {
                            Curry._1(onTreeAltLeftClick, id);
                          })), renderSelection && symbolIsHighlighted && selectionIsOn.contents ? "#ADD6FF" : undefined, renderSelection && symbolIsHighlighted ? (
                        id === clickedId ? "#99bce0" : "#ADD6FF"
                      ) : undefined, cursor, title, undefined));
            selectionIsOn.contents = symbolIsHighlighted;
          }
          
        }), undefined, undefined);
  return elems;
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

var stmtPartMarginLeft = "10px";

var stmtPartMarginTop = String(5) + "px";

var checkMarkSymbol = "\u2713";

function rndProofStatus(proofStatus, longClickEnabled, longClickDelayMs, readyTooltip, waitingTooltip, noJstfTooltip, jstfIsIncorrectTooltip, onReadyIconClicked, onReadyIconAltClicked, onWaitingIconClicked, onErrorIconClicked, onNoJstfIconClicked, param) {
  var commonStyle = {
    display: "inline-block",
    fontWeight: "bold",
    marginTop: stmtPartMarginTop,
    marginLeft: stmtPartMarginLeft,
    width: "13px"
  };
  if (proofStatus === undefined) {
    return React.createElement("span", {
                style: commonStyle
              }, Common.nbsp);
  }
  switch (proofStatus) {
    case /* Ready */0 :
        var style = Object.assign({}, commonStyle, {
              color: "green",
              cursor: Belt_Option.isSome(onReadyIconClicked) || Belt_Option.isSome(onReadyIconAltClicked) ? "pointer" : "default"
            });
        if (onReadyIconAltClicked === undefined) {
          return React.createElement("span", {
                      style: style,
                      title: readyTooltip,
                      onClick: (function (param) {
                          Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                                  Curry._1(clbk, undefined);
                                }));
                        })
                    }, checkMarkSymbol);
        }
        var partial_arg = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, onReadyIconAltClicked, undefined);
        var partial_arg$1 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, (function (param) {
                return Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                              Curry._1(clbk, param);
                            }));
              }), undefined);
        return React.createElement(LongClickSpan.make, {
                    onClick: (function (param) {
                        return MM_react_common.clickHnd2(partial_arg$1, partial_arg, param);
                      }),
                    longClickEnabled: longClickEnabled,
                    longClickDelayMs: longClickDelayMs,
                    onShortClick: (function (clickAttrs) {
                        if (clickAttrs !== undefined) {
                          if (clickAttrs.alt) {
                            return Curry._1(onReadyIconAltClicked, undefined);
                          } else {
                            return Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                                          Curry._1(clbk, undefined);
                                        }));
                          }
                        } else {
                          return Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                                        Curry._1(clbk, undefined);
                                      }));
                        }
                      }),
                    onLongClick: onReadyIconAltClicked,
                    children: checkMarkSymbol,
                    style: style,
                    title: readyTooltip
                  });
    case /* Waiting */1 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "orange",
                          cursor: Belt_Option.isSome(onWaitingIconClicked) ? "pointer" : "default"
                        }),
                    title: waitingTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onWaitingIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "\u223F");
    case /* NoJstf */2 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "red",
                          cursor: Belt_Option.isSome(onNoJstfIconClicked) ? "pointer" : "default"
                        }),
                    title: noJstfTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onNoJstfIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "?");
    case /* JstfIsIncorrect */3 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "red",
                          cursor: Belt_Option.isSome(onErrorIconClicked) ? "pointer" : "default"
                        }),
                    title: jstfIsIncorrectTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onErrorIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "\u2717");
    
  }
}

var make = React.memo((function (param) {
        var typeColors = param.typeColors;
        var src = param.src;
        var proofTreeDto = param.proofTreeDto;
        var wrkCtx = param.wrkCtx;
        var match = MM_wrk_editor.parseJstf(param.jstfText);
        if (match.TAG !== /* Ok */0) {
          return null;
        }
        var jstf = match._0;
        if (jstf === undefined) {
          return null;
        }
        if (typeof src === "number") {
          return null;
        }
        if (src.TAG !== /* Assertion */1) {
          return null;
        }
        var args = src.args;
        var frame = MM_context.getFrame(wrkCtx, src.label);
        if (frame === undefined) {
          return null;
        }
        var asrt = MM_context.frmIntsToSymsExn(wrkCtx, frame, frame.asrt);
        var hyps = [];
        var subs = Belt_HashMapString.make(frame.hyps.length);
        var frmColors = Belt_HashMapString.make(frame.hyps.length);
        frame.hyps.forEach(function (hyp, i) {
              if (hyp.typ === /* E */1) {
                hyps.push(MM_context.frmIntsToSymsExn(wrkCtx, frame, hyp.expr));
                return ;
              }
              var frmSym = MM_context.frmIntToSymExn(wrkCtx, frame, Caml_array.get(hyp.expr, 1));
              Belt_HashMapString.set(subs, frmSym, MM_context.ctxIntsToSymsExn(wrkCtx, Caml_array.get(proofTreeDto.nodes, Caml_array.get(args, i)).expr.slice(1)));
              var typeSym = MM_context.ctxIntToSymExn(wrkCtx, Caml_array.get(hyp.expr, 0));
              var color = Belt_HashMapString.get(typeColors, typeSym);
              if (color !== undefined) {
                return Belt_HashMapString.set(frmColors, frmSym, color);
              }
              
            });
        return React.createElement(MM_cmp_jstf_to_svg.make, {
                    hyps: hyps,
                    hypLabels: jstf.args,
                    asrt: asrt,
                    subs: subs,
                    frmColors: Caml_option.some(frmColors),
                    ctxColors1: Caml_option.some(param.preCtxColors),
                    ctxColors2: Caml_option.some(param.wrkCtxColors)
                  });
      }), (function (param, param$1) {
        return true;
      }));

function userStmtTypeAndIsGoalFromStr(stmtTypeStr) {
  switch (stmtTypeStr) {
    case "e" :
        return [
                /* E */0,
                false
              ];
    case "g" :
        return [
                /* P */1,
                true
              ];
    case "p" :
        return [
                /* P */1,
                false
              ];
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + stmtTypeStr + "' to userStmtType and isGoal."
            },
            Error: new Error()
          };
  }
}

function propsAreSame(a, b) {
  if (a.settingsVer === b.settingsVer && a.settings.customTransforms === b.settings.customTransforms && a.preCtxVer === b.preCtxVer && a.varsText === b.varsText && a.viewOptions.showCheckbox === b.viewOptions.showCheckbox && a.viewOptions.showLabel === b.viewOptions.showLabel && a.viewOptions.showType === b.viewOptions.showType && a.viewOptions.showJstf === b.viewOptions.showJstf && a.viewOptions.inlineMode === b.viewOptions.inlineMode && a.viewOptions.smallBtns === b.viewOptions.smallBtns && a.readOnly === b.readOnly && a.parenAc === b.parenAc && a.stmt.label === b.stmt.label && a.stmt.labelEditMode === b.stmt.labelEditMode && a.stmt.typ === b.stmt.typ && a.stmt.typEditMode === b.stmt.typEditMode && a.stmt.cont === b.stmt.cont && a.stmt.contEditMode === b.stmt.contEditMode && a.stmt.jstfText === b.stmt.jstfText && a.stmt.jstfEditMode === b.stmt.jstfEditMode && Caml_obj.equal(a.stmt.stmtErr, b.stmt.stmtErr) && Caml_obj.equal(a.stmt.syntaxErr, b.stmt.syntaxErr) && Caml_obj.equal(a.stmt.unifErr, b.stmt.unifErr) && a.checkboxDisabled === b.checkboxDisabled && a.checkboxChecked === b.checkboxChecked && Caml_obj.equal(a.stmt.src, b.stmt.src)) {
    return a.stmt.proofStatus === b.stmt.proofStatus;
  } else {
    return false;
  }
}

var make$1 = React.memo((function (param) {
        var openFrameExplorer = param.openFrameExplorer;
        var setShowTabs = param.setShowTabs;
        var addStmtBelow = param.addStmtBelow;
        var addStmtAbove = param.addStmtAbove;
        var onDebug = param.onDebug;
        var onGenerateProof = param.onGenerateProof;
        var checkboxOnChange = param.checkboxOnChange;
        var checkboxChecked = param.checkboxChecked;
        var checkboxDisabled = param.checkboxDisabled;
        var onJstfEditCancel = param.onJstfEditCancel;
        var onJstfEditDone = param.onJstfEditDone;
        var onJstfEditRequested = param.onJstfEditRequested;
        var onSyntaxTreeUpdatedWithoutContentChange = param.onSyntaxTreeUpdatedWithoutContentChange;
        var onContEditCancel = param.onContEditCancel;
        var onContEditDone = param.onContEditDone;
        var onContEditRequested = param.onContEditRequested;
        var onTypEditDone = param.onTypEditDone;
        var onTypEditRequested = param.onTypEditRequested;
        var onLabelEditCancel = param.onLabelEditCancel;
        var onLabelEditDone = param.onLabelEditDone;
        var onLabelEditRequested = param.onLabelEditRequested;
        var stmt = param.stmt;
        var toggleParenAc = param.toggleParenAc;
        var parenAc = param.parenAc;
        var readOnly = param.readOnly;
        var viewOptions = param.viewOptions;
        var showVisByDefault = param.showVisByDefault;
        var defaultStmtType = param.defaultStmtType;
        var longClickDelayMs = param.longClickDelayMs;
        var longClickEnabled = param.longClickEnabled;
        var editStmtsByLeftClick = param.editStmtsByLeftClick;
        var wrkCtxColors = param.wrkCtxColors;
        var preCtxColors = param.preCtxColors;
        var typeColors = param.typeColors;
        var parensMap = param.parensMap;
        var syntaxTypes = param.syntaxTypes;
        var parenCnt = param.parenCnt;
        var frms = param.frms;
        var wrkCtx = param.wrkCtx;
        var settings = param.settings;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return {
                      newText: "",
                      infoExpanded: false,
                      visExpanded: false
                    };
            });
        var setState = match[1];
        var state = match[0];
        var labelRef = React.useRef(null);
        var jstfRef = React.useRef(null);
        var stmtTextFieldRef = React.useRef(null);
        var match$1 = React.useState(function () {
              
            });
        var setSyntaxTreeWasRequested = match$1[1];
        var syntaxTreeWasRequested = match$1[0];
        var match$2 = React.useState(function () {
              
            });
        var setSyntaxTreeError = match$2[1];
        var syntaxTreeError = match$2[0];
        var match$3 = React.useState(function () {
              
            });
        var setSelectionRange = match$3[1];
        var selectionRange = match$3[0];
        var match$4 = React.useState(function () {
              
            });
        var setCopiedToClipboard = match$4[1];
        var copiedToClipboard = match$4[0];
        var match$5 = React.useState(function () {
              
            });
        var setNewTextCursorPosition = match$5[1];
        var newTextCursorPosition = match$5[0];
        React.useEffect((function () {
                if (stmt.labelEditMode) {
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, stmt.label);
                        }));
                } else if (stmt.typEditMode) {
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, MM_wrk_editor.userStmtTypeToStr(stmt.typ));
                        }));
                } else if (stmt.contEditMode) {
                  var contStr = MM_wrk_editor.contToStr(stmt.cont);
                  var contStr$1 = contStr === "" && defaultStmtType !== "" ? defaultStmtType + " " : contStr;
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, contStr$1);
                        }));
                } else if (stmt.jstfEditMode) {
                  Curry._1(setState, (function (st) {
                          var match = stmt.typ;
                          return setNewText(st, match ? stmt.jstfText : MM_wrk_editor.defaultJstfForHyp);
                        }));
                }
                
              }), [
              stmt.labelEditMode,
              stmt.typEditMode,
              stmt.contEditMode,
              stmt.jstfEditMode
            ]);
        React.useEffect((function () {
                if (syntaxTreeError !== undefined) {
                  Curry._1(setSyntaxTreeError, (function (param) {
                          
                        }));
                  MM_react_common.openInfoDialog(modalRef, syntaxTreeError, undefined, undefined, undefined);
                }
                
              }), [syntaxTreeError]);
        React.useEffect((function () {
                var domElem = stmtTextFieldRef.current;
                if (!(domElem == null) && selectionRange !== undefined) {
                  Curry._1(setSelectionRange, (function (param) {
                          
                        }));
                  domElem.setSelectionRange(selectionRange[0], selectionRange[1]);
                }
                
              }), [stmtTextFieldRef.current]);
        React.useEffect((function () {
                if (newTextCursorPosition !== undefined) {
                  Curry._1(setNewTextCursorPosition, (function (param) {
                          
                        }));
                  var domElem = stmtTextFieldRef.current;
                  if (!(domElem == null)) {
                    domElem.selectionStart = newTextCursorPosition;
                    domElem.selectionEnd = newTextCursorPosition;
                  }
                  
                }
                
              }), [newTextCursorPosition]);
        React.useEffect((function () {
                if (syntaxTreeWasRequested !== undefined) {
                  Common.$$setTimeout((function (param) {
                          Curry._1(setSyntaxTreeWasRequested, (function (param) {
                                  
                                }));
                          if (wrkCtx === undefined) {
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return "Cannot build a syntax tree because there was an error setting MM context.";
                                        }));
                          }
                          var match = stmt.cont;
                          if (match.TAG !== /* Text */0) {
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return "Cannot build a syntax tree because stmtCont is a tree.";
                                        }));
                          }
                          var syms = match.syms;
                          var msg = MM_wrk_editor.textToSyntaxTree(Caml_option.valFromOption(wrkCtx), [syms.map(function (s) {
                                        return s.sym;
                                      }).slice(1)], syntaxTypes, frms, settings.allowedFrms.inSyntax, parenCnt, getLastSyntaxType(undefined), setLastSyntaxType);
                          if (msg.TAG === /* Ok */0) {
                            var msg$1 = Caml_array.get(msg._0, 0);
                            if (msg$1.TAG === /* Ok */0) {
                              var syntaxTree = msg$1._0;
                              var stmtContTreeData_text = match.text;
                              var stmtContTreeData_exprTyp = Caml_array.get(syms, 0).sym;
                              var stmtContTreeData_root = MM_wrk_editor.addColorsToSyntaxTree(syntaxTree, Caml_option.some(preCtxColors), Caml_option.some(wrkCtxColors), undefined);
                              var stmtContTreeData_clickedNodeId = Belt_Option.map(MM_wrk_editor.getNodeIdBySymIdx(syntaxTreeWasRequested, syntaxTree), (function (id) {
                                      return [
                                              id,
                                              new Date()
                                            ];
                                    }));
                              var stmtContTreeData = {
                                text: stmtContTreeData_text,
                                exprTyp: stmtContTreeData_exprTyp,
                                root: stmtContTreeData_root,
                                clickedNodeId: stmtContTreeData_clickedNodeId,
                                expLvl: 0
                              };
                              return Curry._1(onSyntaxTreeUpdatedWithoutContentChange, {
                                          TAG: /* Tree */1,
                                          _0: MM_wrk_editor.incExpLvlIfConstClicked(stmtContTreeData)
                                        });
                            }
                            var msg$2 = msg$1._0;
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return msg$2;
                                        }));
                          }
                          var msg$3 = msg._0;
                          Curry._1(setSyntaxTreeError, (function (param) {
                                  return msg$3;
                                }));
                        }), 10);
                }
                
              }), [syntaxTreeWasRequested]);
        var actToggleInfoExpanded = function (param) {
          Curry._1(setState, (function (st) {
                  var st$1 = st.infoExpanded ? setVisExpanded(st, false) : setVisExpanded(st, showVisByDefault);
                  return setInfoExpanded(st$1, !st$1.infoExpanded);
                }));
        };
        var actToggleVisExpanded = function (param) {
          Curry._1(setState, (function (st) {
                  return setVisExpanded(st, !st.visExpanded);
                }));
        };
        var actNewTextUpdated = function (newText) {
          Curry._1(setState, (function (__x) {
                  return setNewText(__x, newText);
                }));
        };
        var actJstfEditRequested = function (param) {
          Curry._1(onJstfEditRequested, undefined);
        };
        var after = function (str, pos) {
          return str.substring(pos + 1 | 0);
        };
        var getLastSymbol = function (str) {
          var idx = str.lastIndexOf(" ");
          if (idx !== -1) {
            return str.substring(idx + 1 | 0);
          } else {
            return str;
          }
        };
        var actLabelEditDone = function (param) {
          Curry._1(onLabelEditDone, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
        };
        var actLabelEditCancel = function (param) {
          Curry._1(onLabelEditCancel, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
        };
        var actTypEditDone = function (newTypStr) {
          var match = userStmtTypeAndIsGoalFromStr(newTypStr);
          Curry._2(onTypEditDone, match[0], match[1]);
        };
        var actTypEditCancel = function (param) {
          Curry._2(onTypEditDone, stmt.typ, stmt.isGoal);
        };
        var actContEditDone = function (param) {
          Curry._1(onContEditDone, state.newText.trim());
        };
        var actContEditCancel = function (param) {
          Curry._1(onContEditCancel, state.newText.trim());
        };
        var actJstfEditDone = function (param) {
          Curry._1(setState, (function (st) {
                  return setInfoExpanded(st, true);
                }));
          Curry._1(onJstfEditDone, state.newText.trim());
        };
        var actJstfEditCancel = function (param) {
          Curry._1(onJstfEditCancel, state.newText.trim());
        };
        var actJstfDeleted = function (param) {
          Curry._1(onJstfEditDone, "");
        };
        var actUpdateSyntaxTreeWithoutContentChange = function (update) {
          var treeData = stmt.cont;
          if (treeData.TAG === /* Text */0) {
            return ;
          } else {
            return Curry._1(onSyntaxTreeUpdatedWithoutContentChange, {
                        TAG: /* Tree */1,
                        _0: Curry._1(update, treeData._0)
                      });
          }
        };
        var actTreeNodeClicked = function (nodeId) {
          actUpdateSyntaxTreeWithoutContentChange(function (treeData) {
                return MM_wrk_editor.incExpLvlIfConstClicked({
                            text: treeData.text,
                            exprTyp: treeData.exprTyp,
                            root: treeData.root,
                            clickedNodeId: [
                              nodeId,
                              new Date()
                            ],
                            expLvl: 0
                          });
              });
        };
        var actUnselect = function (param) {
          actUpdateSyntaxTreeWithoutContentChange(function (treeData) {
                return {
                        text: treeData.text,
                        exprTyp: treeData.exprTyp,
                        root: treeData.root,
                        clickedNodeId: undefined,
                        expLvl: treeData.expLvl
                      };
              });
        };
        var actExpandSelection = function (param) {
          actUpdateSyntaxTreeWithoutContentChange(function (__x) {
                return MM_wrk_editor.updateExpLevel(__x, true);
              });
        };
        var actShrinkSelection = function (param) {
          actUpdateSyntaxTreeWithoutContentChange(function (__x) {
                return MM_wrk_editor.updateExpLevel(__x, false);
              });
        };
        var getSelectedRange = function (param) {
          var match = stmt.cont;
          if (match.TAG === /* Text */0) {
            return ;
          }
          var match$1 = match._0;
          var match$2 = MM_wrk_editor.getIdsOfSelectedNodes(stmt.cont);
          var selectedIds = match$2[1];
          var idxFrom = {
            contents: undefined
          };
          var idxTo = {
            contents: undefined
          };
          Expln_utils_data.traverseTree([
                {
                  contents: false
                },
                {
                  contents: match$1.exprTyp.length
                }
              ], {
                TAG: /* Subtree */0,
                _0: match$1.root
              }, (function (param, node) {
                  if (node.TAG === /* Subtree */0) {
                    return node._0.children;
                  }
                  
                }), undefined, (function (param, node) {
                  var charsPassed = param[1];
                  var selectionIsOn = param[0];
                  if (node.TAG !== /* Subtree */0) {
                    var symbolIsHighlighted = Belt_SetInt.has(selectedIds, node.id);
                    if (selectionIsOn.contents && !symbolIsHighlighted) {
                      idxTo.contents = charsPassed.contents;
                    }
                    if (!selectionIsOn.contents && symbolIsHighlighted) {
                      idxFrom.contents = charsPassed.contents + 1 | 0;
                    }
                    charsPassed.contents = (charsPassed.contents + 1 | 0) + node.sym.length | 0;
                    selectionIsOn.contents = symbolIsHighlighted;
                  }
                  return idxTo.contents;
                }), undefined, undefined);
          var match$3 = idxFrom.contents;
          var match$4 = idxTo.contents;
          if (match$3 !== undefined) {
            if (match$4 !== undefined) {
              return [
                      match$3,
                      match$4
                    ];
            } else {
              return [
                      match$3,
                      MM_wrk_editor.contToStr(stmt.cont).length
                    ];
            }
          }
          
        };
        var replaceSelectionWithNewText = function (newText) {
          var match = getSelectedRange(undefined);
          if (match === undefined) {
            return ;
          }
          var currentText = MM_wrk_editor.contToStr(stmt.cont);
          return currentText.slice(0, match[0]) + newText + currentText.slice(match[1]);
        };
        var actOpenFragmentTransform = function (selectedSubtree) {
          var transformsText = settings.useDefaultTransforms ? (
              settings.useCustomTransforms ? [
                  MM_frag_transform_default_script.fragmentTransformsDefaultScript,
                  settings.customTransforms
                ] : [MM_frag_transform_default_script.fragmentTransformsDefaultScript]
            ) : (
              settings.useCustomTransforms ? [settings.customTransforms] : []
            );
          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                      return null;
                    })), (function (modalId) {
                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                          var closeDialog = function (param) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                          };
                          return React.createElement(MM_cmp_frag_transform.make, {
                                      onCancel: closeDialog,
                                      selectedSubtree: selectedSubtree,
                                      transformsText: transformsText,
                                      onInsertAbove: (function (transformedSelectionText) {
                                          Belt_Option.forEach(replaceSelectionWithNewText(transformedSelectionText), addStmtAbove);
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                        }),
                                      onInsertBelow: (function (transformedSelectionText) {
                                          Belt_Option.forEach(replaceSelectionWithNewText(transformedSelectionText), addStmtBelow);
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                        }),
                                      onUpdateCurrent: (function (transformedSelectionText) {
                                          Belt_Option.forEach(replaceSelectionWithNewText(transformedSelectionText), onContEditDone);
                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                        })
                                    });
                        }));
                }));
        };
        var rndLabel = function (param) {
          if (stmt.labelEditMode) {
            var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actLabelEditCancel, undefined);
            var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actLabelEditDone, undefined);
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        style: {
                          marginTop: stmtPartMarginTop,
                          marginLeft: stmtPartMarginLeft
                        },
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: state.newText,
                            size: "small",
                            style: {
                              width: "150px"
                            },
                            onChange: (function (param) {
                                return Expln_React_common.evt2str((function (str) {
                                              var newText = str.replace(symbolsNotAllowedInLabelRegex, "");
                                              Curry._1(setState, (function (__x) {
                                                      return setNewText(__x, newText);
                                                    }));
                                            }), param);
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                              }),
                            autoFocus: true,
                            title: "Enter to save, Esc to cancel"
                          }), React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(null)
                          }, rndIconButton(React.createElement(Save, {}), actLabelEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actLabelEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined, undefined)));
          }
          var chgLabelShortcutName = longClickEnabled ? "Long click (Alt + Left-click)" : "Alt + Left-click";
          var showJstfShortcutName = longClickEnabled ? "Short click (Left-click)" : "Left-click";
          var partial_arg$2 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, actToggleInfoExpanded, undefined);
          var partial_arg$3 = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, onLabelEditRequested, undefined);
          var tmp = {
            display: "inline-block",
            marginTop: stmtPartMarginTop,
            marginLeft: stmtPartMarginLeft
          };
          var tmp$1 = readOnly ? undefined : "pointer";
          if (tmp$1 !== undefined) {
            tmp.cursor = tmp$1;
          }
          return React.createElement(LongClickSpan.make, {
                      onClick: (function (param) {
                          return MM_react_common.clickHnd2(partial_arg$3, partial_arg$2, param);
                        }),
                      longClickEnabled: longClickEnabled,
                      longClickDelayMs: longClickDelayMs,
                      onShortClick: (function (clickAttrs) {
                          if (clickAttrs !== undefined && clickAttrs.alt) {
                            return Curry._1(onLabelEditRequested, undefined);
                          } else {
                            return actToggleInfoExpanded(undefined);
                          }
                        }),
                      onLongClick: onLabelEditRequested,
                      children: stmt.label,
                      style: tmp,
                      title: readOnly ? undefined : chgLabelShortcutName + " to change. Alt is sometimes labelled Opt. " + showJstfShortcutName + " to show/hide the justification for provable."
                    });
        };
        var rndSelectionButtons = function (param) {
          var style = viewOptions.smallBtns ? ({
                minHeight: "26px",
                minWidth: "30px",
                padding: "0px"
              }) : undefined;
          var match = stmt.cont;
          var clickedTimeStr;
          if (match.TAG === /* Text */0) {
            clickedTimeStr = "1";
          } else {
            var match$1 = match._0.clickedNodeId;
            clickedTimeStr = match$1 !== undefined ? match$1[1].toISOString() : "1";
          }
          var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actUnselect, undefined);
          var partial_arg$1 = MM_react_common.kbrdClbkMake("s", undefined, undefined, undefined, actShrinkSelection, undefined);
          var partial_arg$2 = MM_react_common.kbrdClbkMake("w", undefined, undefined, undefined, actExpandSelection, undefined);
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      style: {
                        marginTop: "3px"
                      },
                      children: Caml_option.some(null)
                    }, React.createElement(ButtonGroup, {
                          variant: "outlined",
                          size: "small",
                          children: null
                        }, React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTreeWithoutContentChange(function (__x) {
                                        return MM_wrk_editor.updateExpLevel(__x, true);
                                      });
                                }),
                              title: "Expand selection, W",
                              style: style,
                              children: Caml_option.some(React.createElement(ZoomOutMap, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTreeWithoutContentChange(function (__x) {
                                        return MM_wrk_editor.updateExpLevel(__x, false);
                                      });
                                }),
                              title: "Shrink selection, S",
                              style: style,
                              children: Caml_option.some(React.createElement(ZoomInMap, {}))
                            }), readOnly ? null : React.createElement(Button, {
                                onClick: (function (param) {
                                    Belt_Option.forEach(MM_wrk_editor.getSelectedText(stmt.cont), (function (selectedText) {
                                            var match = stmt.cont;
                                            if (match.TAG === /* Text */0) {
                                              return ;
                                            } else {
                                              return Curry._1(addStmtAbove, match._0.exprTyp + " " + selectedText);
                                            }
                                          }));
                                  }),
                                title: "Add new step above",
                                style: style,
                                children: Caml_option.some(React.createElement(Logout, {
                                          style: {
                                            transform: "rotate(-90deg)"
                                          }
                                        }))
                              }), readOnly ? null : React.createElement(Button, {
                                onClick: (function (param) {
                                    Belt_Option.forEach(MM_wrk_editor.getSelectedText(stmt.cont), (function (selectedText) {
                                            var match = stmt.cont;
                                            if (match.TAG === /* Text */0) {
                                              return ;
                                            } else {
                                              return Curry._1(addStmtBelow, match._0.exprTyp + " " + selectedText);
                                            }
                                          }));
                                  }),
                                title: "Add new step below",
                                style: style,
                                children: Caml_option.some(React.createElement(Logout, {
                                          style: {
                                            transform: "rotate(90deg)"
                                          }
                                        }))
                              }), readOnly ? null : React.createElement(Button, {
                                onClick: (function (param) {
                                    Belt_Option.forEach(MM_wrk_editor.getSelectedSubtreeFromStmtCont(stmt.cont), actOpenFragmentTransform);
                                  }),
                                title: "Transform",
                                style: style,
                                children: Caml_option.some(React.createElement(ShapeLineSharp, {}))
                              }), React.createElement(Button, {
                              onClick: (function (param) {
                                  var selectedText = MM_wrk_editor.getSelectedText(stmt.cont);
                                  if (selectedText !== undefined) {
                                    Expln_utils_promise.promiseMap(MM_react_common.copyToClipboard(selectedText), (function (param) {
                                            Curry._1(setCopiedToClipboard, (function (timerId) {
                                                    if (timerId !== undefined) {
                                                      Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                                    }
                                                    return Caml_option.some(Common.$$setTimeout((function (param) {
                                                                      Curry._1(setCopiedToClipboard, (function (param) {
                                                                              
                                                                            }));
                                                                    }), 1000));
                                                  }));
                                          }));
                                    return ;
                                  }
                                  
                                }),
                              title: "Copy to the clipboard",
                              style: style,
                              children: Caml_option.some(React.createElement(ContentCopy, {}))
                            }), readOnly ? null : React.createElement(Button, {
                                onClick: (function (param) {
                                    Expln_utils_promise.promiseMap(MM_react_common.readFromClipboard(undefined), (function (clipboardContents) {
                                            Belt_Option.forEach(replaceSelectionWithNewText(clipboardContents), Curry.__1(onContEditDone));
                                          }));
                                  }),
                                title: "Paste from the clipboard to the selection",
                                style: style,
                                children: Caml_option.some(React.createElement(ContentPaste, {}))
                              }), readOnly ? null : React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(setSelectionRange, (function (param) {
                                            return getSelectedRange(undefined);
                                          }));
                                    Curry._1(onContEditRequested, undefined);
                                  }),
                                title: "Edit",
                                style: style,
                                children: Caml_option.some(React.createElement(Edit, {}))
                              }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUnselect(undefined);
                                }),
                              title: "Unselect, Esc",
                              style: style,
                              children: Caml_option.some(React.createElement(CancelOutlined, {}))
                            })), Belt_Option.isSome(copiedToClipboard) ? "Copied to the clipboard." : null, MM_react_common.rndHiddenTextField(clickedTimeStr, (function (param) {
                            return MM_react_common.kbrdHnd3(partial_arg$2, partial_arg$1, partial_arg, param);
                          }), undefined));
        };
        var rndCont = function (param) {
          if (stmt.contEditMode) {
            var windowWidth = window.innerWidth;
            var textFieldWidth;
            if (viewOptions.inlineMode) {
              textFieldWidth = windowWidth - 40 | 0;
            } else {
              var checkBoxWidth = viewOptions.showCheckbox ? 48 : 0;
              var labelWidth;
              if (viewOptions.showLabel) {
                var domElem = labelRef.current;
                labelWidth = (domElem == null) ? 0 : domElem.offsetWidth + 10 | 0;
              } else {
                labelWidth = 0;
              }
              var typWidth = viewOptions.showType ? 28 : 0;
              var jstfWidth;
              if (viewOptions.showJstf) {
                var domElem$1 = jstfRef.current;
                jstfWidth = (domElem$1 == null) ? 0 : domElem$1.offsetWidth + 10 | 0;
              } else {
                jstfWidth = 0;
              }
              textFieldWidth = Math.max(200, ((((windowWidth - checkBoxWidth | 0) - labelWidth | 0) - typWidth | 0) - jstfWidth | 0) - 40 | 0);
            }
            var partial_arg = MM_react_common.kbrdClbkMake("p", true, undefined, undefined, toggleParenAc, undefined);
            var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actContEditCancel, undefined);
            var partial_arg$2 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actContEditDone, undefined);
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        style: {
                          marginTop: stmtPartMarginTop,
                          marginLeft: stmtPartMarginLeft
                        },
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            inputRef: Caml_option.some(stmtTextFieldRef),
                            value: state.newText,
                            size: "small",
                            style: {
                              width: String(textFieldWidth) + "px"
                            },
                            multiline: true,
                            onChange: (function (evt) {
                                var selectionStart = evt.target.selectionStart;
                                var value = evt.target.value;
                                var prevLen = state.newText.length;
                                var newLen = value.length;
                                var newText;
                                if (parenAc && (prevLen + 1 | 0) === newLen && selectionStart > 1 && " " === value.charAt(selectionStart - 1 | 0)) {
                                  var pos = selectionStart - 1 | 0;
                                  var prevBefore = state.newText.substring(0, pos);
                                  var newBefore = value.substring(0, pos);
                                  var prevAfter = after(state.newText, pos - 1 | 0);
                                  var newAfter = after(value, pos);
                                  if (prevBefore === newBefore && prevAfter === newAfter) {
                                    var lastSymbol = getLastSymbol(newBefore);
                                    var closingParen = Belt_HashMapString.get(parensMap, lastSymbol);
                                    if (closingParen !== undefined) {
                                      var newText$1 = newBefore + "  " + closingParen + newAfter;
                                      Curry._1(setNewTextCursorPosition, (function (param) {
                                              return selectionStart;
                                            }));
                                      newText = newText$1;
                                    } else {
                                      newText = value;
                                    }
                                  } else {
                                    newText = value;
                                  }
                                } else {
                                  newText = value;
                                }
                                Curry._1(setState, (function (__x) {
                                        return setNewText(__x, newText);
                                      }));
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd3(partial_arg$2, partial_arg$1, partial_arg, param);
                              }),
                            inputProps: {
                              style: {
                                fontFamily: "monospace"
                              }
                            },
                            autoFocus: true,
                            title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                          }), React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(null)
                          }, parenAc ? rndIconButton(React.createElement(Code, {}), toggleParenAc, undefined, "Parentheses autocomplete is On; press Alt+P to turn it Off", undefined, undefined, undefined) : rndIconButton(React.createElement(CodeOff, {}), toggleParenAc, undefined, "Parentheses autocomplete is Off; press Alt+P to turn it On", Caml_option.some(undefined), undefined, undefined), rndIconButton(React.createElement(Save, {}), actContEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actContEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined, undefined)));
          }
          var match = stmt.cont;
          var textIsSelected;
          textIsSelected = match.TAG === /* Text */0 ? false : Belt_Option.isSome(match._0.clickedNodeId);
          var howToSelect = editStmtsByLeftClick ? (
              longClickEnabled ? "<long-click> (Alt+<left-click>) to select" : "Alt+<left-click> to select"
            ) : (
              longClickEnabled ? "<short-click> to select" : "<left-click> to select"
            );
          var title = editStmtsByLeftClick ? (
              longClickEnabled ? "<short-click> to change, " + howToSelect : "<left-click> to change, " + howToSelect
            ) : (
              longClickEnabled ? "<long-click> (Alt+<left-click>) to change, " + howToSelect : "Alt+<left-click> to change, " + howToSelect
            );
          var onTextLeftClick = editStmtsByLeftClick ? (function (param) {
                Curry._1(onContEditRequested, undefined);
              }) : (function (idx) {
                Curry._1(setSyntaxTreeWasRequested, (function (param) {
                        return idx;
                      }));
              });
          var onTextAltLeftClick = editStmtsByLeftClick ? (function (idx) {
                Curry._1(setSyntaxTreeWasRequested, (function (param) {
                        return idx;
                      }));
              }) : (function (param) {
                Curry._1(onContEditRequested, undefined);
              });
          var onTreeLeftClick = editStmtsByLeftClick ? (function (param) {
                Curry._1(onContEditRequested, undefined);
              }) : actTreeNodeClicked;
          var onTreeAltLeftClick = editStmtsByLeftClick ? actTreeNodeClicked : (function (param) {
                Curry._1(onContEditRequested, undefined);
              });
          var elems = [React.createElement(Paper, {
                  style: {
                    backgroundColor: Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) ? "rgb(255,230,230)" : "rgb(255,255,235)",
                    fontFamily: "monospace",
                    fontSize: "1.3em",
                    padding: "1px 3px"
                  },
                  children: Caml_option.some(rndContText(stmt.cont, undefined, onTextLeftClick, onTextAltLeftClick, onTreeLeftClick, onTreeAltLeftClick, longClickEnabled, longClickDelayMs, editStmtsByLeftClick ? "auto" : "pointer", true, readOnly ? howToSelect : title, undefined))
                })];
          if (Belt_Option.isSome(syntaxTreeWasRequested)) {
            elems.push(React.createElement("span", undefined, "Building a syntax tree..."));
          }
          if (textIsSelected) {
            elems.push(rndSelectionButtons(undefined));
          }
          return React.createElement(Expln_React_Column.make, {
                      spacing: 0,
                      style: {
                        marginTop: stmtPartMarginTop,
                        marginLeft: stmtPartMarginLeft
                      },
                      children: Caml_option.some(elems)
                    });
        };
        var rndTyp = function (param) {
          if (stmt.typEditMode) {
            var match = stmt.typ;
            var typStrLowerCase = match ? (
                stmt.isGoal ? "g" : "p"
              ) : "e";
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        children: Caml_option.some(null)
                      }, React.createElement(FormControl, {
                            size: "small",
                            style: {
                              marginTop: stmtPartMarginTop,
                              marginLeft: stmtPartMarginLeft
                            },
                            children: Caml_option.some(React.createElement(Select, {
                                      value: typStrLowerCase,
                                      onChange: (function (param) {
                                          return Expln_React_common.evt2str(actTypEditDone, param);
                                        }),
                                      children: Caml_option.some(null)
                                    }, React.createElement(MenuItem, {
                                          value: "e",
                                          children: "H - (Essential) Hypothesis"
                                        }), React.createElement(MenuItem, {
                                          value: "p",
                                          children: "P - Provable Statement"
                                        }), React.createElement(MenuItem, {
                                          value: "g",
                                          children: "G - Goal Statement"
                                        })))
                          }), rndIconButton(React.createElement(CancelOutlined, {}), actTypEditCancel, undefined, "Cancel", Caml_option.some(undefined), undefined, undefined));
          }
          var match$1 = stmt.typ;
          var typStr = match$1 ? (
              stmt.isGoal ? "G" : "P"
            ) : "H";
          var chgTypShortcutName = longClickEnabled ? "Long click (Alt + Left-click)" : "Alt + Left-click";
          var showJstfShortcutName = longClickEnabled ? "Short click (Left-click)" : "Left-click";
          var partial_arg = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, actToggleInfoExpanded, undefined);
          var partial_arg$1 = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, onTypEditRequested, undefined);
          var tmp = {
            display: "inline-block",
            fontWeight: "bold",
            marginTop: stmtPartMarginTop,
            marginLeft: stmtPartMarginLeft
          };
          var tmp$1 = readOnly ? undefined : "pointer";
          if (tmp$1 !== undefined) {
            tmp.cursor = tmp$1;
          }
          return React.createElement(LongClickSpan.make, {
                      onClick: (function (param) {
                          return MM_react_common.clickHnd2(partial_arg$1, partial_arg, param);
                        }),
                      longClickEnabled: longClickEnabled,
                      longClickDelayMs: longClickDelayMs,
                      onShortClick: (function (clickAttrs) {
                          if (clickAttrs !== undefined && clickAttrs.alt) {
                            return Curry._1(onTypEditRequested, undefined);
                          } else {
                            return actToggleInfoExpanded(undefined);
                          }
                        }),
                      onLongClick: onTypEditRequested,
                      children: typStr,
                      style: tmp,
                      title: readOnly ? undefined : chgTypShortcutName + " to change step type between P (provable), G (goal) and H (hypothesis). Alt is sometimes labelled Opt. " + showJstfShortcutName + " to show/hide the justification for provable."
                    });
        };
        var visualizationIsAvailable = Belt_Option.isSome(wrkCtx) && Belt_Option.isSome(stmt.proofTreeDto) && Belt_Option.isSome(stmt.src);
        var getFrmLabelBkgColor = function (label) {
          var frm = MM_substitution.frmsGetByLabel(frms, label);
          if (frm !== undefined) {
            return MM_react_common.getFrmLabelBkgColor(frm.frame, settings);
          }
          
        };
        var rndJstf = function (isInline, textFieldWidth) {
          if (stmt.jstfEditMode) {
            var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actJstfEditCancel, undefined);
            var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actJstfEditDone, undefined);
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        style: {
                          marginTop: stmtPartMarginTop,
                          marginLeft: stmtPartMarginLeft
                        },
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: state.newText,
                            label: "Justification",
                            size: "small",
                            style: {
                              width: textFieldWidth
                            },
                            multiline: true,
                            onChange: (function (param) {
                                return Expln_React_common.evt2str(actNewTextUpdated, param);
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                              }),
                            autoFocus: true,
                            title: "Enter to save, Esc to cancel"
                          }), React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(null)
                          }, rndIconButton(React.createElement(Save, {}), actJstfEditDone, true, "Save, Enter", undefined, undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actJstfEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined, undefined), rndIconButton(React.createElement(DeleteForever, {}), actJstfDeleted, undefined, "Clear", "red", undefined, undefined)));
          }
          var jstfTextStr = stmt.typ === /* E */0 ? "HYP" : stmt.jstfText;
          var jstfText;
          if (stmt.typ === /* E */0) {
            jstfText = jstfTextStr;
          } else {
            var match = MM_wrk_editor.parseJstf(jstfTextStr);
            if (match.TAG === /* Ok */0) {
              var match$1 = match._0;
              if (match$1 !== undefined) {
                var label = match$1.label;
                var tmp = {
                  cursor: "pointer",
                  borderRadius: "3px"
                };
                var tmp$1 = getFrmLabelBkgColor(label);
                if (tmp$1 !== undefined) {
                  tmp.backgroundColor = tmp$1;
                }
                var partial_arg$2 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, (function (param) {
                        Curry._1(setShowTabs, true);
                        Curry._1(openFrameExplorer, label);
                      }), undefined);
                var partial_arg$3 = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, actJstfEditRequested, undefined);
                jstfText = React.createElement("span", undefined, match$1.args.join(" ") + " : ", React.createElement("span", {
                          className: "underline-on-hover",
                          style: tmp,
                          onClick: (function (param) {
                              return MM_react_common.clickHnd2(partial_arg$3, partial_arg$2, param);
                            })
                        }, label));
              } else {
                jstfText = jstfTextStr;
              }
            } else {
              jstfText = jstfTextStr;
            }
          }
          var padding = jstfTextStr.trim() === "" ? "11px 16px" : "1px";
          var title = longClickEnabled ? "<long-click> (Alt+<left-click>) to change; click on the label to open a proof explorer tab" : "Alt+<left-click> to change; click on the label to open a proof explorer tab";
          var partial_arg$4 = true;
          var tmp$2;
          if (isInline) {
            tmp$2 = React.createElement("span", {
                  style: {
                    display: "none"
                  }
                });
          } else {
            var btns = [];
            if (jstfTextStr.trim() !== "") {
              btns.push(rndIconButton(React.createElement(DeleteForever, {}), actJstfDeleted, undefined, "Delete justification", Caml_option.some(undefined), "d", undefined));
            }
            btns.push(rndIconButton(React.createElement(VisibilityOff, {}), actToggleInfoExpanded, undefined, "Hide justification", Caml_option.some(undefined), "h", undefined));
            if (visualizationIsAvailable) {
              btns.push(rndIconButton(React.createElement(AccountTree, {
                            style: {
                              transform: "rotate(90deg)"
                            }
                          }), actToggleVisExpanded, undefined, "Show/Hide visualization", Caml_option.some(undefined), "v", undefined));
            }
            tmp$2 = React.createElement(Expln_React_Row.make, {
                  style: {
                    marginLeft: "10px"
                  },
                  children: Caml_option.some(btns)
                });
          }
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      spacing: 0,
                      style: {
                        marginTop: stmtPartMarginTop,
                        marginLeft: stmtPartMarginLeft
                      },
                      children: Caml_option.some(null)
                    }, React.createElement(LongClickPaper.make, {
                          onClick: (function (param) {
                              return MM_react_common.clickHnd(undefined, partial_arg$4, undefined, undefined, actJstfEditRequested, undefined, param);
                            }),
                          longClickEnabled: longClickEnabled,
                          longClickDelayMs: longClickDelayMs,
                          onShortClick: (function (clickAttrs) {
                              if (clickAttrs !== undefined && clickAttrs.alt) {
                                return Curry._1(onJstfEditRequested, undefined);
                              }
                              
                            }),
                          onLongClick: actJstfEditRequested,
                          children: jstfText,
                          style: {
                            padding: padding,
                            whiteSpace: "nowrap",
                            overflowWrap: "normal"
                          },
                          title: readOnly ? undefined : title,
                          ref_: Caml_option.some(jstfRef)
                        }), tmp$2);
        };
        var rndJstfVisualization = function (param) {
          if (visualizationIsAvailable) {
            return Caml_option.some(React.createElement(make, {
                            wrkCtx: Belt_Option.getExn(wrkCtx),
                            proofTreeDto: Belt_Option.getExn(stmt.proofTreeDto),
                            jstfText: stmt.jstfText,
                            src: Belt_Option.getExn(stmt.src),
                            typeColors: typeColors,
                            preCtxColors: preCtxColors,
                            wrkCtxColors: wrkCtxColors
                          }));
          }
          
        };
        var rndInfoBody = function (param) {
          if (stmt.typ !== /* P */1) {
            return ;
          }
          var jstf = !viewOptions.showJstf && (state.infoExpanded || stmt.jstfEditMode) ? Caml_option.some(rndJstf(false, "600px")) : undefined;
          var jstfVis = state.infoExpanded && (state.visExpanded || viewOptions.showJstf) ? rndJstfVisualization(undefined) : undefined;
          if (Belt_Option.isNone(jstf) && Belt_Option.isNone(jstfVis)) {
            return ;
          } else {
            return Caml_option.some(React.createElement(Expln_React_Column.make, {
                            spacing: 0,
                            children: Caml_option.some(null)
                          }, Belt_Option.getWithDefault(jstf, null), Belt_Option.getWithDefault(jstfVis, null)));
          }
        };
        var rndContAndInfoBody = function (param) {
          var infoBody = rndInfoBody(undefined);
          if (infoBody !== undefined) {
            return React.createElement(Expln_React_Column.make, {
                        spacing: 0,
                        children: Caml_option.some(null)
                      }, rndCont(undefined), Caml_option.valFromOption(infoBody));
          } else {
            return rndCont(undefined);
          }
        };
        var rndProofStatusInner = function (param) {
          var readyTooltip = longClickEnabled ? "A proof is ready, <long-click> (Alt+<left-click>) to show a completed proof" : "A proof is ready, Alt+<left-click> to show a completed proof";
          return rndProofStatus(stmt.proofStatus, longClickEnabled, longClickDelayMs, readyTooltip, "Justification for this step is correct", "Justification cannot be determined automatically. Click to debug.", "Justification is incorrect. Click to debug.", actToggleInfoExpanded, onGenerateProof, actToggleInfoExpanded, onDebug, onDebug, undefined);
        };
        var rndProofStatusTd = function (tdStyle) {
          if (Belt_Option.isSome(stmt.proofStatus)) {
            return React.createElement("td", {
                        style: tdStyle
                      }, rndProofStatusInner(undefined));
          } else {
            return null;
          }
        };
        var rndProofStatusRow = function (param) {
          if (Belt_Option.isSome(stmt.proofStatus)) {
            return rndProofStatusInner(undefined);
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndCheckbox = function (param) {
          return React.createElement(Checkbox, {
                      style: {
                        marginTop: stmtPartMarginTop,
                        marginLeft: stmtPartMarginLeft,
                        padding: "0px"
                      },
                      disabled: checkboxDisabled,
                      checked: checkboxChecked,
                      onChange: (function (param) {
                          return Expln_React_common.evt2bool(checkboxOnChange, param);
                        })
                    });
        };
        var rndCheckboxTd = function (tdStyle) {
          if (viewOptions.showCheckbox) {
            return React.createElement("td", {
                        style: tdStyle
                      }, rndCheckbox(undefined));
          } else {
            return null;
          }
        };
        var rndCheckboxRow = function (param) {
          if (viewOptions.showCheckbox) {
            return rndCheckbox(undefined);
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndLabelTd = function (tdStyle) {
          if (viewOptions.showLabel) {
            return React.createElement("td", {
                        style: tdStyle
                      }, rndLabel(undefined));
          } else {
            return null;
          }
        };
        var rndLabelRow = function (param) {
          if (viewOptions.showLabel) {
            return rndLabel(undefined);
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndTypTd = function (tdStyle) {
          if (viewOptions.showType) {
            return React.createElement("td", {
                        style: tdStyle
                      }, rndTyp(undefined));
          } else {
            return null;
          }
        };
        var rndTypRow = function (param) {
          if (viewOptions.showType) {
            return rndTyp(undefined);
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndJstfTd = function (tdStyle) {
          if (viewOptions.showJstf) {
            return React.createElement("td", {
                        style: tdStyle
                      }, rndJstf(true, "150px"));
          } else {
            return null;
          }
        };
        var rndJstfRow = function (param) {
          if (viewOptions.showJstf) {
            return rndJstf(true, "150px");
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        if (viewOptions.inlineMode) {
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "flex-start",
                      spacing: 0,
                      children: Caml_option.some(null)
                    }, rndCheckboxRow(undefined), rndProofStatusRow(undefined), rndLabelRow(undefined), rndTypRow(undefined), rndJstfRow(undefined), rndContAndInfoBody(undefined));
        }
        var tdStyle = {
          borderCollapse: "collapse",
          padding: "0px"
        };
        return React.createElement("table", {
                    style: {
                      borderCollapse: "collapse",
                      cursor: Belt_Option.isSome(syntaxTreeWasRequested) ? "wait" : "",
                      padding: "0px"
                    }
                  }, React.createElement("tbody", undefined, React.createElement("tr", {
                            style: {
                              verticalAlign: "top"
                            }
                          }, rndCheckboxTd(tdStyle), rndProofStatusTd(tdStyle), rndLabelTd(tdStyle), rndTypTd(tdStyle), rndJstfTd(tdStyle), React.createElement("td", {
                                style: tdStyle
                              }, rndContAndInfoBody(undefined)))));
      }), propsAreSame);

exports.rndProofStatus = rndProofStatus;
exports.make = make$1;
exports.rndContText = rndContText;
exports.getLastSyntaxType = getLastSyntaxType;
exports.setLastSyntaxType = setLastSyntaxType;
/* stmtPartMarginTop Not a pure module */
